<template>
  <div>
    <a-card title="月调度">
      <a-row :gutter="16">
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px">
          <a-input v-model="searchForm.search" placeholder="请输入关键词" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="max-width: 300px; margin-bottom: 12px">
          <a-range-picker v-model="dateRange" :placeholder="['开始日期', '结束日期']" format="YYYY-MM-DD" @change="onDateChange"
            allowClear />
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>

        <div style="margin-bottom: 12px; float: right">
          <a-button type="primary" icon="plus" style="margin: 0 8px" @click="openFormModal(form)">新增</a-button>
        </div>
      </a-row>

      <a-row style="margin-top: 12px">
        <a-table size="small" :columns="columns" :dataSource="items" :pagination="pagination" rowKey="id"
          :loading="loading" @change="tableChange">
          <div slot="is_active" slot-scope="value">
            <a-tag :color="value ? 'green' : 'red'">{{ value ? "激活" : "冻结" }}</a-tag>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button icon="copy" size="small" @click="copyRecord(item)">复制</a-button>
              <a-button icon="eye" size="small" @click="openViewModal(item)">查看</a-button>
              <a-button icon="edit" size="small" @click="openFormModal(item)">编辑</a-button>
              <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
                <a-button type="danger" icon="delete" size="small">删除</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
    <form-modal 
      :visible="visible" 
      :form="targetItem" 
      :clientsClassificationOptions="clientsClassificationItems"
      :isReadonly="isReadonly"
      @cancel="visible = false"
      @create="create" 
      @update="update" />
    <a-modal v-model="importLoading" :footer="null" :maskClosable="false" :closable="false">
      <div><a-spin style="margin-right: 12px" />正在导入中, 请等待...</div>
    </a-modal>
  </div>
</template>

<script>
import { exportExcel } from "@/utils/excel";
import { clientExport } from "@/api/export";
import { clientTemplate, clientImport } from "@/api/import";
import { monthControlList, monthControlDel } from "@/api/control";

export default {
  name: "Warehouse",
  components: {
    FormModal: () => import("./FormModal.vue"),
  },
  data() {
    return {
      pagination: { current: 1, total: 0, pageSize: 10 },
      columns: [
        {
          title: "会议名称",
          dataIndex: "others.meeting_name"
        },
        {
          title: "主持人",
          dataIndex: "others.host"
        },
        {
          title: "会议日期",
          dataIndex: "others.meeting_date"
        },
        {
          title: "会议地点",
          dataIndex: "others.meeting_location"
        },
        {
          title: "出席人员",
          dataIndex: "others.attendance"
        },
        {
          title: "会议内容记录",
          dataIndex: "others.meeting_record"
        },
        {
          title: "下个月食品安全管理重点工作调度计划",
          dataIndex: "others.months_plan"
        },
        {
          title: "汇报人",
          dataIndex: "others.reported_by"
        },
        {
          title: "负责人",
          dataIndex: "others.head"
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          width: "210px",
        },
      ],
      searchForm: {
        search: "",
        page: 1,
        page_size: 10,
        check_date_start: "",
        check_date_end: ""
      },
      dateRange: [], // 添加这个属性
      loading: false,
      items: [],
      clientsClassificationItems: [],
      visible: false,
      targetItem: { others: {} },
      form: { others: { meeting_name: '', host: '', meeting_date: '', meeting_location: '', attendance: '', meeting_record: '', months_plan: '', reported_by: '', head: '' } },
      isReadonly: false,
      importLoading: false,
    };
  },
  computed: {},
  methods: {
    initialize() {
      this.list();
    },
    list() {
      this.loading = true;
      monthControlList(this.searchForm)
        .then((data) => {
          this.pagination.total = data.count;
          this.items = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create() {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    update() {
      this.list();
    },
    search() {
      this.pagination.current = 1;
      this.searchForm.page = 1;
      this.list();
    },
    openViewModal(item) {
      this.isReadonly = true;
      this.targetItem = JSON.parse(JSON.stringify(item));
      this.visible = true;
    },
    openFormModal(item) {
      this.isReadonly = false;
      this.targetItem = JSON.parse(JSON.stringify(item));
      this.visible = true;
    },
    onDateChange(dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.searchForm.check_date_start = dateStrings[0];
        this.searchForm.check_date_end = dateStrings[1];
      } else {
        this.searchForm.check_date_start = "";
        this.searchForm.check_date_end = "";
      }
      // 添加自动搜索功能
      this.search();
    },
    copyRecord(item) {
      // 复制记录,移除id和创建时间等字段,保留业务数据
      const copiedItem = { 
        others: { ...item.others }
      };
      // 清除不需要复制的字段
      delete copiedItem.id;
      delete copiedItem.create_at;
      delete copiedItem.update_at;
      
      this.targetItem = copiedItem;
      this.visible = true;
      this.$message.success('已复制记录,请修改后保存');
    },
    destroy(id) {
      monthControlDel({ id: id })
        .then((data) => {
          this.$message.success("删除成功");
          this.list();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exportExcel() {
      clientExport(this.searchForm)
        .then((resp) => {
          exportExcel(resp.data, "客户列表");
        })
        .catch((err) => {
          this.$message.error(err.response.data.error);
        });
    },
    downloadTemplate() {
      clientTemplate()
        .then((resp) => {
          exportExcel(resp.data, "客户导入模板");
        })
        .catch((err) => {
          this.$message.error(err.response.data.error);
        });
    },
    importExcel(item) {
      let data = new FormData();
      data.append("file", item.file);
      this.importLoading = true;
      setTimeout(() => {
        clientImport(data)
          .then(() => {
            this.$message.success("导入成功");
            this.list();
          })
          .catch((err) => {
            alert("导入错误:" + "\n" + err.response.data.join("\n"));
          })
          .finally(() => {
            this.importLoading = false;
          });
      }, 1000);
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.searchForm.page_size = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.searchForm.ordering = `${sorter.order == "descend" ? "-" : ""}${sorter.field}`;
      this.list();
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
